/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Clipboard } from "@capacitor/clipboard";
import { Capacitor } from "@capacitor/core";
import React from "react";
import { toast } from "react-toastify";

import ToastIcon from "../components/ToastIcon";

import { error, log } from "./log";

export const copyTextToClipboard = async (text: string) => {
  if (Capacitor.isNativePlatform()) {
    // Native platform logic (Capacitor)
    try {
      await Clipboard.write({
        string: text,
      }).then(() => {
        log("Text copied to clipboard using Capacitor");
        toast("Details copied to clipboard", {
          type: "success",
          icon: <ToastIcon>inventory</ToastIcon>,
        });
      });
    } catch (err) {
      error("Failed to copy text to clipboard on native platform:", err);
    }
  } else {
    // Web platform logic
    try {
      await navigator.clipboard.writeText(text).then(() => {
        log("Text copied to clipboard using Web API");
        toast("Details copied to clipboard", {
          type: "success",
          icon: <ToastIcon>inventory</ToastIcon>,
        });
      });
    } catch (err) {
      error("Failed to copy text to clipboard on web platform:", err);
    }
  }
};
